import { FormControl, Box } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'

import React from 'react'
import { Item } from './Item.js'

// const sxUIElementItem = {
//     width: { xs: '50%', md: '80%' },
//     // width: { xs: '50%', md: '54%' },
//     pl: { xs: 2, md: 2 },
//     // pt: { xs: 0, md: 3 },
// }

export default function UIElement({ sxProp, children }) {
    // let {
    //     py: { md },
    // } = sxProp
    // const radio_2 = md === 0.0 ? true : false
    // let sxUISelectItem = {}
    // if (radio_2 && children[1]) {
    //     sxUISelectItem = { py: { xs: 0, md: 1 } }
    // }
    // && children[1]?.props?.id?.includes('select') pt: { md: 0.0 }, pb: { md: 0.0 }
    return (
        <Box

        // xs={12}
        // md={6}
        // className={className}
        // sx={{
        //     display: 'flex',
        //     justifyContent: {
        //         xs: 'center',
        //         md: 'flex-start',
        //     },
        //     ...sxProp,
        // }}
        >
            <Item
                elevation={0}
                // @ts-ignore
                sx={sxProp}
                // sx={{ ...sxUIElementItem, ...sxUISelectItem }}
            >
                <FormControl fullWidth>{children}</FormControl>
            </Item>
        </Box>
    )
}
